export default __webpack_public_path__ + "static/media/HeadLogo.f05158ba.png";